import type { ReactNode } from "react";

/**
 * Saytning umumiy qismlari. Ular oz va sodda — sayt bitta sahifadan va
 * ikkita ro'yxatdan iborat, shuning uchun alohida dizayn tizimi ortiqcha.
 */

/** Sahifa kengligi. Matn qatori 75 belgidan uzun bo'lmasin. */
export function Container({
  className = "",
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return <div className={`mx-auto w-full max-w-5xl px-5 sm:px-8 ${className}`}>{children}</div>;
}

/** Asosiy harakat tugmasi. Tashqi havola sifatida ham ishlaydi. */
export function ActionLink({
  href,
  tone = "gold",
  external = false,
  children,
}: {
  href: string;
  tone?: "gold" | "green" | "outline" | "night";
  external?: boolean;
  children: ReactNode;
}) {
  const tones = {
    gold: "bg-gold text-night hover:brightness-105",
    green: "bg-green text-white hover:brightness-110",
    night: "bg-night text-night-ink hover:brightness-125",
    outline: "border border-night-line text-night-ink hover:bg-night-2",
  } as const;

  return (
    <a
      href={href}
      {...(external ? { target: "_blank", rel: "noreferrer noopener" } : {})}
      className={`inline-flex items-center justify-center rounded-lg px-5 py-3 text-base font-semibold transition ${tones[tone]}`}
    >
      {children}
    </a>
  );
}

/** Bo'lim sarlavhasi: nom va tagida bitta izoh qatori. */
export function SectionTitle({
  title,
  lead,
  onNight = false,
}: {
  title: string;
  lead?: string;
  onNight?: boolean;
}) {
  return (
    <header className="mb-8">
      <h2
        className={`font-cond text-3xl leading-none font-bold tracking-wide sm:text-4xl ${
          onNight ? "text-night-ink" : "text-ink"
        }`}
      >
        {title}
      </h2>
      {lead ? (
        <p className={`mt-2 max-w-[60ch] ${onNight ? "text-night-hint" : "text-ink-2"}`}>{lead}</p>
      ) : null}
    </header>
  );
}

/** Oltin maydon chizig'i — bo'limlar orasidagi ajratgich. */
export function PitchRule() {
  return <div className="pitch-line" aria-hidden="true" />;
}

/** Yorug' varaqdagi kartochka. */
export function Card({
  className = "",
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`border-line bg-card rounded-xl border ${className}`}>{children}</div>
  );
}

/**
 * Namunaviy ma'lumot haqida ogohlantirish.
 *
 * Sahifa bo'sh turmasligi uchun namunaviy kontent ko'rsatiladi, lekin
 * o'quvchi uni haqiqiy deb o'ylamasligi kerak.
 */
export function SampleNotice({ text }: { text: string }) {
  return (
    <p className="border-gold/40 bg-gold/10 text-ink-2 mb-6 rounded-lg border px-4 py-2.5 text-sm">
      {text}
    </p>
  );
}
